'use strict';

angular.module('app.performanceReportTierPerformance')
    .directive('performanceReportTierPerformanceDirective', function () {
        return {
            controller: 'performanceReportTierPerformanceCtrl',
            templateUrl: 'app/measure/performanceReport/performanceReportTierPerformance/performanceReportTierPerformance.html?app_v=deployDate',
            restrict: 'E',
            scope: {

            },
            replace: true,
            transclude: true
        };
    })